export const DEFAULT_CURRENCY = "EUR";

export const CURRENCY_STATE = {
    ACTIVE: 1,
    INACTIVE: 2
}